import React, {ReactElement} from 'react';
import {
  Button,
  InputAdornment,
  InputBase,
  makeStyles,
  Typography
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
// import Format from '@shared/utils/DateTimeUtils'
import {useSnackbar} from 'notistack';
import moment from 'moment';
import './CustomDateTimePicker.scss';
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import DateIcon from '@components/system/MyIcons/DateIcon';
import {connect} from 'react-redux';
import {_scheduleSendDate} from '@shared/store/actions/PaymentActions';
import {scheduleReminders} from '@shared/services/DueInvoiceServices';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
const useStyles = makeStyles({
  dialog: {
    '& .MuiDialog-paperScrollPaper': {
      width: '55rem',
      marginTop: '3rem',
      height: '45rem',
      display: 'flex',
      flexDirection: 'row'
    }
  },
  dateInputField: {
    maxWidth: '7rem',
    flexShrink: 0
  },
  root: {
    '& .MuiPopover-paper': {
      position: 'none'
    }
  },
  fieldsWrapper: {
    padding: '3rem 3rem 3rem 2rem',
    maxWidth: '325px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  DateTimeHeader: {
    fontSize: '1.3rem',
    padding: '1rem 0rem',
    textAlign: 'start',
    width: '15rem'
  },
  InputDiv: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  InputFileds: {
    padding: '0 1rem',
    backgroundColor: '#e9ecef',
    marginBottom: '1rem',
    width: '15rem'
  },
  actionsWrapper: {
    display: 'flex',
    marginTop: '130px',
    justifyContent: 'space-between',
    columnGap: '1rem',
    width: '15rem'
  },
  cancel: {
    fontSize: '1rem',
    textTransform: 'capitalize'
  },
  scheduleSend: {
    fontSize: '1rem',
    paddingLeft: '10px',
    paddingRight: '10px'
  }
});

const CustomDateTimePicker = (props: any): ReactElement => {
  const classes = useStyles();
  const {
    close,
    groupId,
    checkBoxes,
    reminderType,
    clinicId,
    selectAll = false,
    dueType = '',
    selectedStatementDueStatus = [],
    selectedNotificationCount = [],
    paymentAction,
    scheduleType,
    handleCustomMessageDialog
  } = props;
  const {getValues, setValue} = useForm();
  const [dateTime, setDateTime] = React.useState<Date>(new Date());
  const {t} = useTranslation();
  const [selectedTime, setSelectedTime] = React.useState<any>();
  const {enqueueSnackbar} = useSnackbar();

  const handleDateTime = (date: Date): void => {
    const m = moment(date);
    setValue('set_date', m.format('DD/MM/YYYY'));
    setValue('set_time', m.format('HH:mm'));
    setDateTime(date);
  };

  const handleCancel = () => {
    close(true);
  };

  const handleScheduleSend = (data: any) => {
    setSelectedTime(getValues('set_time'));

    // setting up schedule send date to redux state
    props._scheduleSendDate(dateTime);

    if (scheduleType) {
      // method to open custom popups
      if (typeof handleCustomMessageDialog === 'function') {
        handleCustomMessageDialog();
      }
    } else {
      const remindersObject: any = {
        guarantors: selectAll ? [] : checkBoxes.tableCheckBoxValues,
        reminder_date: dateTime,
        reminder_type: reminderType,
        select_all: selectAll,
        due_type: dueType,
        notification_count:
          selectedNotificationCount && selectedNotificationCount.length
            ? selectedNotificationCount[0].value
            : '',
        payment_action: paymentAction
      };
      if (selectedNotificationCount && selectedNotificationCount.length) {
        remindersObject['notification_count'] =
          selectedNotificationCount[0].value;
      }
      if (selectedStatementDueStatus && selectedStatementDueStatus.length) {
        remindersObject['payment_flow_status'] =
          selectedStatementDueStatus[0].value;
      }
      scheduleReminders(groupId, clinicId, remindersObject)
        .then(res => {
          if (res) {
            enqueueSnackbar(
              t('DUE_INVOICES.SCHEDULE_REMINDER'),
              SnackBarConfig('s')
            );
          }
        })
        .catch(error => {
          enqueueSnackbar(
            (error && error.message) || t('DUE_INVOICES.REQUEST_SENT_ERROR'),
            SnackBarConfig('e')
          );
          // throw error;
        });
    }
    close(false);
  };

  const handleAccept = (date: any) => {
    //
  };

  // const handleTime = (event:any) => {
  //   const time:any = event.target.value;
  //   handleSelectedTime(time);
  // }

  const onChangeTime = (event: any) => {
    const time = event.target.value;
    const tempdatetime: Date = dateTime;
    const hhmm: number[] = time.split(':');
    setSelectedTime(time);
    tempdatetime.setHours(hhmm[0]);
    tempdatetime.setMinutes(hhmm[1]);
    setDateTime(tempdatetime);
  };

  const RenderTextField = (): ReactElement => {
    return <div />;
  };

  const RenderToolBar = (): ReactElement => {
    return (
      <div className={classes.fieldsWrapper}>
        <form>
          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <Typography className={classes.DateTimeHeader}>
              {t('DUE_INVOICES.SELECT_DATE_TIME')}
            </Typography>
          </div>
          <div className={classes.InputDiv}>
            <InputBase
              id="set_date"
              name="set_date"
              placeholder={t('DUE_INVOICES.PLACEHOLDERS.SELECT_DATE')}
              defaultValue={moment(dateTime).format('DD/MM/YYYY')}
              value={moment(dateTime).format('DD/MM/YYYY')}
              readOnly={true}
              endAdornment={
                <InputAdornment position="end" style={{paddingRight: '4px'}}>
                  <DateIcon />
                </InputAdornment>
              }
              className={classes.InputFileds}
            />
          </div>
          <div className={classes.InputDiv}>
            <InputBase
              id="set_time"
              name="set_time"
              type="time"
              placeholder={t('DUE_INVOICES.PLACEHOLDERS.SET_TIME')}
              defaultValue={moment(dateTime).format('HH:mm')}
              value={selectedTime}
              className={classes.InputFileds}
              onChange={e => onChangeTime(e)}
            />
          </div>
          <div className={classes.actionsWrapper}>
            <Button onClick={handleCancel} className={classes.cancel}>
              {t('DUE_INVOICES.PLACEHOLDERS.CANCEL')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={handleScheduleSend}
              className={classes.scheduleSend}>
              {t('DUE_INVOICES.PLACEHOLDERS.SCHEDULE_SEND')}
            </Button>
          </div>
        </form>
      </div>
    );
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        className='custom-date-time-picker'
        variant="dialog"
        autoOk
        value={dateTime}
        onChange={(date: any) => handleDateTime(date)}
        open={true}
        disabled={false}
        TextFieldComponent={RenderTextField}
        disablePast
        cancelLabel
        okLabel
        ToolbarComponent={RenderToolBar}
        onAccept={date => handleAccept(date)}
      />
    </MuiPickersUtilsProvider>
  );
};

function mapStateToProps(state: any): any {
  return {
    groupId: state.auth.groupId
  };
}

export default connect(mapStateToProps, {_scheduleSendDate})(
  CustomDateTimePicker
);
